<template>
  <div class="ContentQuote" v-if="hasContent">
    <p class="ContentQuote__quote" v-html="content.quote" />
    <p v-if="hasAuthor">{{ content.author }}</p>  
  </div>
</template>

<script>
export default {
  name: 'ContentQuote',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasContent() {
      return this.content.quote;
    },
    hasAuthor() {
      return this.content.author;
    }
  }
}
</script>

<style lang="scss">
  .ContentQuote {
    padding: 16px !important;
    // background: $gray_light !important;
    background: $antraciet_blauw_lightest;
    line-height: 24px !important;

    &__quote {
      font-style: italic;
    }

    h1, h2, h3, h4, h5, h6, strong {
      color: $antraciet_blauw;
    }
  }
</style>
